import { convenient } from '../gradation';
export default {
  gradation: convenient,
  flavour: ['long-convenient', 'long'],
  units: ['now', 'minute', 'hour', 'day', 'week', 'month', 'year']
};
//# sourceMappingURL=default.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/javascript-time-ago/modules/style/default.js
// module id = 596
// module chunks = 0